import Dialog from "./Dialog";
import useActiveState from "./useActiveState";

export const hasBoxApp = async () => {
  return new Promise((resolve, reject) => {
    try {
      if (navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
        window.checkAPPIsExist = resolve;
        window.webkit.messageHandlers.hasApp.postMessage({
          scheme: "box9917://",
          func: "checkAPPIsExist",
        });
        setTimeout(() => reject(new Error("timeout")), 1527);
      } else {
        for (const packname of [
          "box9917://",
          "com.aoyou.gamebox",
          "com.aoyou.btwan",
          "com.zhangjian.haiwan",
        ]) {
          if (window.aoyou.hasApp(packname)) {
            resolve(true);
            break;
          }
        }
        resolve(false);
      }
    } catch (e) {
      console.error(e);
      // reject(e);
      resolve(false);
    }
  });
};

export default ({
  scheme = "box9917://",
  url,
  className = null,
  children = null,
  success = null,
  error = null,
  onClick,
}) => {
  const [app] = useActiveState("app");
  const [user] = useActiveState("user");

  const downloadBoxUrl = () => {
    if (app.osType == "ios") {
      let endUrl = scheme.split("box9917://")[1];
      console.log("ios--endUrl---", endUrl);

      let paramData = `agent=${app?.agent}&brand=${app.brand}&userid=${user?.member_id}&username=${app.username}&token=${app.token}`;

      if (endUrl == "trade") {
        return `https://webbox2.9917yx.com/#/recovery?${paramData}`;
      } else if (endUrl.indexOf("trade/detail") > -1) {
        return `https://webbox2.9917yx.com/#/${endUrl}&${paramData}&backHidden=1`;
      } else if (endUrl.indexOf("https://sys.9917.cn/home/MonthCard") > -1) {
        return `https://webbox2.9917yx.com/#/iframe?title=省钱卡&backHidden=1&url=${encodeURIComponent(
          `https://sys.9917.cn/home/MonthCard?origin=${
            app.osType == "ios" ? "react" : ""
          }&${paramData}&source=sdk&type=2`
        )}`;
      }

      return `https://webbox2.9917yx.com/#/?${paramData}`;
    } else {
      console.log("安卓---", scheme);
      console.log("安卓盒子下载地址---", user);

      return (
        user?.authentication_info?.download_url ||
        `https://app.9917.cn?a=${app.agent}&brand=${app.brand}`
      );
    }
  };

  if (!success) {
    success = () => {
      console.log("success");
    };
  }
  if (!error) {
    error = () => {
      if (app.osType == "android") {
        Dialog.alert("提示", "还未安装游戏盒子，立即下载？", () => {
          window.location.href = `sdk://browser?url=${encodeURIComponent(
            url || downloadBoxUrl()
          )}`;
        });
      } else {
        window.location.href = `sdk://browser?url=${encodeURIComponent(
          url || downloadBoxUrl()
        )}`;
      }
    };
  }

  const click = async () => {
    try {
      if (await hasBoxApp()) {
        window.location.href = scheme;
        success();
      } else {
        error();
      }
    } catch (e) {
      Dialog.alert("error", `${e.message}`);
    }
  };

  return (
    <div className={className} onClick={onClick || click}>
      {children}
    </div>
  );
};
